import Modal from '../../../components/common/Modal'
import Button from '../../../components/common/Button'

interface Message {
  id: number
  name: string
  email: string
  subject: string
  message: string
  is_read: boolean
  is_processed: boolean
  ip_address?: string
  created_at: string
}

interface MessageDetailProps {
  message: Message
  onClose: () => void
  onDelete: (messageId: number) => void
}

function MessageDetail({ message, onClose, onDelete }: MessageDetailProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date)
  }

  const handleDelete = () => {
    onDelete(message.id)
    onClose()
  }

  const footer = (
    <>
      <Button variant="outline" onClick={onClose}>
        Fermer
      </Button>
      <Button variant="secondary" onClick={handleDelete}>
        Supprimer
      </Button>
    </>
  )

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Détail du message"
      footer={footer}
    >
      <div className="message-detail">
        <div className="message-detail-section">
          <h3>Informations de contact</h3>
          <div className="message-detail-grid">
            <div className="message-detail-field">
              <label>Nom</label>
              <p>{message.name}</p>
            </div>
            <div className="message-detail-field">
              <label>Email</label>
              <p>
                <a href={`mailto:${message.email}`} className="message-email-link">
                  {message.email}
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="message-detail-section">
          <h3>Sujet</h3>
          <p className="message-detail-subject">{message.subject}</p>
        </div>

        <div className="message-detail-section">
          <h3>Message</h3>
          <div className="message-detail-content">
            {message.message}
          </div>
        </div>

        <div className="message-detail-section">
          <h3>Métadonnées</h3>
          <div className="message-detail-grid">
            <div className="message-detail-field">
              <label>Date de réception</label>
              <p>{formatDate(message.created_at)}</p>
            </div>
            {message.ip_address && (
              <div className="message-detail-field">
                <label>Adresse IP</label>
                <p className="message-ip">{message.ip_address}</p>
              </div>
            )}
            <div className="message-detail-field">
              <label>Statut de lecture</label>
              <p>
                <span className={`status-badge ${message.is_read ? 'status-read' : 'status-unread'}`}>
                  {message.is_read ? 'Lu' : 'Non lu'}
                </span>
              </p>
            </div>
            <div className="message-detail-field">
              <label>Statut de traitement</label>
              <p>
                <span className={`status-badge ${message.is_processed ? 'status-processed' : 'status-pending'}`}>
                  {message.is_processed ? 'Traité' : 'En attente'}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default MessageDetail
